import * as React from 'react';
import Autocomplete from '../common/Autocomplete';


export default function Assignation(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketUpdateForm = props.ticketUpdateForm
  const companiesList = props.companiesList
  const areasList = props.areasList
  const personsList = props.personsList


  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Asignación</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Compañía'
            placeholder='Compañía'
            disabled={action === 'view'}
            options={companiesList}
            value={ticketUpdateForm.company}
            name='company'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Área'
            placeholder='Área'
            disabled={action === 'view'}
            options={areasList}
            name='area'
            value={ticketUpdateForm.area}
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Técnico'
            placeholder='Técnico'
            disabled={action === 'view'}
            options={personsList}
            name='technician'
            value={ticketUpdateForm.technician}
            handleSelection={handleSelection}
          />
        </div>

      </div>
    </React.Fragment >
  );
}
